import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const STANDTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.StandType.Name')
    .required()
    .minLength(1)
    .maxLength(40)
    .build(),
  FieldBuilder
    .text('code', 'Entity.StandType.Code')
    .minLength(1)
    .maxLength(10)
    .build(),
  FieldBuilder
    .text('lastCharacter', 'Entity.StandType.LastCharacter')
    .required()
    .minLength(1)
    .maxLength(1)
    .build(),
  FieldBuilder
    .checkbox('isComercial', 'Entity.StandType.IsComercial')
    .build(),
];

export const STANDTYPE_CONFIG = {
  entityName: 'StandType',
  localizationKey: 'Planning::Entity.StandType',
  fields: STANDTYPE_FIELDS,
  permission: 'PlanningLocation.StandTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
};
